import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { registerSW } from "virtual:pwa-register";
import posthog from "posthog-js";
import { PostHogErrorBoundary, PostHogProvider } from "@posthog/react";
import "./index.css";
import App from "./App.tsx";
import { AuthProvider } from "./context/AuthContext";
import { RealtimeProvider } from "./context/RealtimeProvider";
import { disabledPostHogClient, shouldEnablePostHog } from "./lib/posthogConfig";

const posthogProjectToken = import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN;
const posthogHost = import.meta.env.VITE_PUBLIC_POSTHOG_HOST;
const posthogEnabled = shouldEnablePostHog({
  projectToken: posthogProjectToken,
  host: posthogHost,
  appHostname: window.location.hostname,
  enabledOverride: import.meta.env.VITE_PUBLIC_POSTHOG_ENABLED,
});

if (posthogEnabled) {
  posthog.init(posthogProjectToken, {
    api_host: posthogHost,
    defaults: "2026-01-30",
  });
}

const posthogClient = posthogEnabled ? posthog : disabledPostHogClient;
const queryClient = new QueryClient();
registerSW({ immediate: true });

//App entry point. StrictMode is dev only safety checks.App
//BrowserRouter enables client-side routing. (routing context)
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <PostHogProvider client={posthogClient}>
      <PostHogErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <RealtimeProvider>
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </RealtimeProvider>
          </AuthProvider>
        </QueryClientProvider>
      </PostHogErrorBoundary>
    </PostHogProvider>
  </StrictMode>,
);
